export default {
  options: function options(state) {
    return state.options;
  },
  information: function information(state) {
    return state.information;
  },
  encodedCustomizable: function encodedCustomizable(state) {
    return state.encodedCustomizable;
  },
  customizable: function customizable(state) {
    return state.customizable;
  },
  selectedOption: function selectedOption(state) {
    return state.selectedOption;
  },
  configurator: function configurator(state) {
    return state.configurator;
  },
  price: function price(state) {
    return state.price;
  }
};